import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCustomerAuth } from "../contexts/CustomerAuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogle } = useCustomerAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = hash?.split("session_id=")[1]?.split("&")[0];

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    loginWithGoogle(sessionId)
      .then(() => {
        toast.success("Signed in with Google!");
        navigate("/account", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [location.hash, loginWithGoogle, navigate]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="auth-callback">
      <div className="text-center">
        <div className="spinner mx-auto mb-4" />
        <p className="text-lg font-bold">Signing you in...</p>
      </div>
    </div>
  );
}
